import { useEffect, useRef, useState} from "react";
import { useTranslation } from "react-i18next";
import { SelectedAge } from "../../../models/SelectedAge";
import './componentsStyle.css';
export type Props = {
  customSelectedAge:number,
  onSetCustomAge:(age:number)=>void;
  presetAge?: SelectedAge;
}
const CustomAgeComponent:React.FC<Props>=({customSelectedAge,onSetCustomAge, presetAge})=>{
    const inputRef = useRef<HTMLInputElement>(null);
    const [isFocused,setFocusState]=useState<boolean>(false)
    const { t,i18n } = useTranslation();
    useEffect(()=>{
      setCustomAgeText(buildAgelabel(customSelectedAge))
    },[t,i18n,customSelectedAge])
    let chartClasses = ((customSelectedAge!==0 &&  (presetAge === SelectedAge.none || typeof presetAge === "undefined") && !isFocused) ? ' active': '');
    const buildAgelabel=(customAge:number):string=>{
        if(customAge===0 || (presetAge !== SelectedAge.none && typeof presetAge !== "undefined")){
            return t('filter_button_other_age')
        }
        else if(customAge===1){
            if(i18n.language==='fr')
                return customAge+" an";
            else
                return "Age "+customAge;
        }
        else{
            if(i18n.language==='fr')
                return customAge+" ans";
            else
                return "Age "+customAge;
        }
      }

    const [customAgeText,setCustomAgeText] = 
    useState<string>(buildAgelabel(customSelectedAge))

    
     const onChange=(event:any)=>{
          if(event.target.value!=="" || !isNaNModified(event.target.value)){
            if(event.target>90){
              setCustomAgeText("90")
            }
            else{
              setCustomAgeText(event.target.value)
            }
         }
         else{
            setCustomAgeText("")
         } 
      };

      const onFocus=(event:any)=>{
        setFocusState(true)
        setCustomAgeText("")
      }

      const onkeydown=(event:any)=>{
        var key = event.keyCode || event.charCode;
        if( key === 8 || key === 46 ){
        setCustomAgeText("")
        }
        else if(event.key === "Enter"){
          inputRef.current?.blur()
          displayValue(event.target.value)
        }
      }

      function displayValue(value:any){
        if(value==="" || isNaNModified(value) ){
          setCustomAgeText(buildAgelabel(customSelectedAge))
        }
        else{
            if(value==='0'){
                setCustomAgeText(t('filter_button_other_age').toString())
               onSetCustomAge(0)
            }
             else if(value==='65'){
                setCustomAgeText(t('filter_button_other_age').toString())
                onSetCustomAge(65)
            } 
            else{
                if(parseInt(value)>90){
                  setCustomAgeText(buildAgelabel(90))
                  onSetCustomAge(90)
                }
                else{
                setCustomAgeText(buildAgelabel(parseInt(value)))
                onSetCustomAge(parseInt(value))
                }
            }
        }
      }

      const onFocusOut=(event:any)=>{
        displayValue(event.target.value)
        setFocusState(false)
      }
      const isNaNModified = (inputStr: string) => {
        var numericRepr = parseInt(inputStr);
        return isNaN(numericRepr) || numericRepr.toString().length !== inputStr.length || numericRepr<0;
      }

    useEffect(()=>{
     if(customSelectedAge===0 && !isFocused ){
      setCustomAgeText(t('filter_button_other_age').toString())
     }
    },[customSelectedAge])
    return(<div className="custom-age-container">
            <button
              className="decrementer-age"
              aria-label="décrémenter âge"
              aria-controls="custom-age-input"
              onClick={ () => {
                 if(customSelectedAge>0){
                   onSetCustomAge(customSelectedAge-1)
                 }
                }}
             >
              -
            </button>

            <div className={`age-container${chartClasses}`}>
              <input
                id="custom-age-input"
                ref={inputRef} 
                type="text"
                value={customAgeText}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onFocusOut}
                onKeyDown={onkeydown}
                aria-describedby="label-filtre-age"
              />
            </div>

            <button
              className="incrementer-age"
              aria-label="incrémenter âge"
              aria-controls="custom-age-input"
              onClick={ () => {
                if(customSelectedAge<90){
                    onSetCustomAge(customSelectedAge+1)
                   /*  if(customSelectedAge===64){
                       setCustomAgeText(t('filter_button_other_age').toString())
                    } */
                    //else{
                    //}
                }
                else{
                  onSetCustomAge(90)
                }
              }}
            >
              +
            </button>
        
    </div>)

}

export default CustomAgeComponent